/* eslint-disable import/order */
import React from 'react';
import { MenuIdPlans } from '@jira/navigation-apps__constants/src/MenuIdPlans.tsx';
import type PlansDirectoryType from '@jira/spa-apps__directories-plans/src/PlansDirectoryType.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { plansDirectoryRoute } from '@jira/router-routes__directories-routes/src/plansDirectoryRoute.tsx';
import { PlansDirectorySkeleton } from '@jira/platform__skeletons/src/ui/directories/FiltersDirectorySkeleton.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Route } from '@atlassian/react-resource-router';

const LazyPlansDirectory = lazyForPaint<typeof PlansDirectoryType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-plans-directory", jiraSpaEntry: "async-plans-directory" */ '@jira/spa-apps__directories-plans/src/PlansDirectoryType.tsx'
		),
	),
);

const PlansDirectoryComponent = () => (
	<LazyPage Page={LazyPlansDirectory} pageId="plans-directory" shouldShowSpinner={false} />
);

export const plansDirectoryRouteEntry: Route = createEntry(plansDirectoryRoute, () => ({
	group: 'directories',
	// eslint-disable-next-line no-restricted-syntax
	component: PlansDirectoryComponent,
	skeleton: PlansDirectorySkeleton,
	layout: globalLayout,
	resources: [...getNavigationResources()],

	navigation: {
		menuId: MenuIdPlans,
	},

	forPaint: [LazyAtlassianNavigation, LazyPlansDirectory],
	supportsPreviewPanel: true,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
